import type { FieldFunctionOptions, Reference } from '@apollo/client';

type Args<T> = {
  fieldName: string;
  from?: Parameters<FieldFunctionOptions['readField']>[1];
  value: T | Reference | null;
} & Pick<FieldFunctionOptions, 'isReference' | 'readField'>;

/**
 * Calls readField on the entire field if the field is being provided as a Reference
 * instead of as the normalized object.
 *
 * @param args.fieldName The field name being read
 * @param args.from The cached object being read from
 * @param args.value The value of the field being read
 * @param args.isReference The apollo client isReference function
 * @param args.readField The apollo client readField function
 * @return field The normalized field object or null if not found
 */
export function readFieldIfReference<T>({
  fieldName,
  from,
  isReference,
  readField,
  value,
}: Args<T>) {
  if (!value) return null;
  if (!isReference(value)) return value;

  const read = readField<T>(fieldName, from);

  if (!read) return null;

  return read;
}
